"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _EngagementTypes = require("customer-data-objects/engagement/EngagementTypes");

var _default = _react.PropTypes.oneOf([_EngagementTypes.CALL, _EngagementTypes.EMAIL, _EngagementTypes.MEETING, _EngagementTypes.NOTE]);

exports.default = _default;
module.exports = exports.default;